import { createBrowserClient } from '@supabase/ssr'

export const createClient = () => {
    const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
    const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

    if (!supabaseUrl || !supabaseAnonKey) {
        console.error('Supabase Environment Variables missing!');
        console.error('URL:', supabaseUrl);
        console.error('Key:', supabaseAnonKey ? 'Set' : 'Not Set');
    }

    // Configure with explicit localStorage for session persistence
    return createBrowserClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            // Persist session across browser sessions
            persistSession: true,
            // Use localStorage instead of sessionStorage
            storage: typeof window !== 'undefined' ? window.localStorage : undefined,
            // Auto refresh tokens before expiry
            autoRefreshToken: true,
            // Detect session from URL (for email confirmations, etc.)
            detectSessionInUrl: true,
            // Flow type for better security
            flowType: 'pkce'
        }
    });
}

